"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/specialitySection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SpecialitySection346sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" | "5s" | "6s" | "7s" | "8s" */
    dataWowDuration: string;
    /** Detected variants: "Urology" | "Orthopedic" | "Cardiologist" | "Dentist" | "Neurology" | "Pediatrics" | "Veterinary" | "Psychiatrist" */
    link0Text: ReactNode;
    /** Detected variants: "21 Doctors" | "30 Doctors" | "15 Doctors" | "35 Doctors" | "25 Doctors" | "10 Doctors" | "20 Doctors" | "12 Doctors" */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/icons/specilaity-01.svg" | "/Templates/Doccure/img/icons/specilaity-02.svg" | "/Templates/Doccure/img/icons/specilaity-03.svg" | "/Templates/Doccure/img/icons/specilaity-04.svg" | "/Templates/Doccure/img/icons/specilaity-05.svg" | "/Templates/Doccure/img/icons/specilaity-06.svg" | "/Templates/Doccure/img/icons/specilaity-07.svg" | "/Templates/Doccure/img/icons/specilaity-08.svg" */
    src: string;
    /** Detected variants: "col-xl-3 col-lg-4 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "speciality-item-two w-100 wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "speciality-info" */
    div0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorsGrid" */
    href?: string;
    /** Detected variants: "speciality-icon" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.doctorsGrid" */
    link0Href?: string;
    /** Detected variants: "speciality" */
    alt?: string;
    /** Detected variants: "link-icon" */
    link0ClassName2?: string;
    /** Detected variants: "all_routes.doctorsGrid" */
    link0Href2?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
};
export type HomeTwoSpecialitySectionGeneratedProps = {
    divDiv0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: SpecialitySection346sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div0Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: SpecialitySection346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Specialities" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/section-icon.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Medical Support For" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Every Need." */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    specialitySection346s: SpecialitySection346sItem[];
    specialitySection346sItemWrapper?: (item: SpecialitySection346sItem, content: ReactNode) => ReactNode;
    specialitySection346sRenderer?: (defaultNode: ReactNode) => ReactNode;
    specialitySection346sLinkVisible?: boolean;
    specialitySection346sLinkRenderer?: (item: SpecialitySection346sItem, defaultNode: ReactNode) => ReactNode;
    specialitySection346sImageVisible?: boolean;
    specialitySection346sImageRenderer?: (item: SpecialitySection346sItem, defaultNode: ReactNode) => ReactNode;
    specialitySection346sH3Visible?: boolean;
    specialitySection346sH3Renderer?: (item: SpecialitySection346sItem, defaultNode: ReactNode) => ReactNode;
    specialitySection346sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    specialitySection346sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: SpecialitySection346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    specialitySection346sH3Props?: Partial<ComponentProps<"h3">> | ((item: SpecialitySection346sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwoSpecialitySectionGenerated: FC<HomeTwoSpecialitySectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Specialities",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/section-icon.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Medical Support For",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Every Need.",
    divDiv0Div0Div0H30H3Props,
    divDiv0Div0Div0H30Link0LinkProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Link0LinkProps,
    sectionDiv0Div1ClassName,
    specialitySection346s,
    specialitySection346sItemWrapper,
    specialitySection346sRenderer,
    specialitySection346sLinkVisible,
    specialitySection346sLinkRenderer,
    specialitySection346sImageVisible,
    specialitySection346sImageRenderer,
    specialitySection346sH3Visible,
    specialitySection346sH3Renderer,
    specialitySection346sLinkProps,
    specialitySection346sImageProps,
    specialitySection346sH3Props,
}) => {
    return (
        <section className="section speciality-section-two">
            <div className="container">
                <div className="section-header section-header-two">
                    <div className="section-sub-title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title mb-0" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center g-4"}>
                    {renderCollectionNode(
                        specialitySection346s,
                        (item: SpecialitySection346sItem) => (
                            <div className={item.className ?? "col-xl-3 col-lg-4 col-md-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "speciality-item-two w-100 wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "speciality-info"}>
                                        {renderItemNode(specialitySection346sLinkVisible, specialitySection346sLinkRenderer, item, (
                                            <SmartLink href={item.link0Href ?? "all_routes.doctorsGrid"} className={item.link0ClassName ?? "speciality-icon"} {...(typeof specialitySection346sLinkProps === "function" ? specialitySection346sLinkProps(item) : (specialitySection346sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(specialitySection346sImageVisible, specialitySection346sImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "speciality"} {...(typeof specialitySection346sImageProps === "function" ? specialitySection346sImageProps(item) : (specialitySection346sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <div>
                                            {renderItemNode(specialitySection346sH3Visible, specialitySection346sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof specialitySection346sH3Props === "function" ? specialitySection346sH3Props(item) : (specialitySection346sH3Props ?? {}))} {...(typeof divDiv0Div0Div0H30H3Props === "function" ? divDiv0Div0Div0H30H3Props(item) : (divDiv0Div0Div0H30H3Props ?? {}))}>
                                                    {renderItemNode(specialitySection346sLinkVisible, specialitySection346sLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "all_routes.doctorsGrid"} {...(typeof specialitySection346sLinkProps === "function" ? specialitySection346sLinkProps(item) : (specialitySection346sLinkProps ?? {}))} {...(typeof divDiv0Div0Div0H30Link0LinkProps === "function" ? divDiv0Div0Div0H30Link0LinkProps(item) : (divDiv0Div0Div0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                            <p>{item.p0Text}</p>
                                        </div>
                                    </div>
                                    {renderItemNode(specialitySection346sLinkVisible, specialitySection346sLinkRenderer, item, (
                                        <SmartLink href={item.link0Href2 ?? "all_routes.doctorsGrid"} className={item.link0ClassName2 ?? "link-icon"} {...(typeof specialitySection346sLinkProps === "function" ? specialitySection346sLinkProps(item) : (specialitySection346sLinkProps ?? {}))} {...(typeof divDiv0Link0LinkProps === "function" ? divDiv0Link0LinkProps(item) : (divDiv0Link0LinkProps ?? {}))}>
                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        ),
                        specialitySection346sItemWrapper,
                        specialitySection346sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeTwoSpecialitySectionGenerated;
